import snsAxiosClient from '../common/http/http-sns';
import formatString from '../utils/formatString';
import { get, reduce, toPairs } from 'lodash';

interface buyItAgainPayload {
  excludeCartItems: boolean;
  excludeOOS: boolean;
  excludeOrderItems: boolean;
  storeId: string;
  banner: string;
  host: string;
  pageURL: string;
  placement: string;
  uiPageSize: number;
  assortmentChannel: string;
}

function buyItAgainService(environmentVariables, user, upcomingOrder) {
  const headers = get(environmentVariables, 'BIA_API_HEADERS_POST', {});
  const banner = get(headers, 'x-swy-banner');

  const options = {
    headers: {
      'X-Access-Token': `${get(user, 'authToken')}`,
      ...headers,
    },
  };

  const queryParams = {
    includeOffer: true,
  };

  const payload: buyItAgainPayload = {
    banner: banner,
    excludeCartItems: true,
    excludeOOS: true,
    excludeOrderItems: false,
    host: get(window, 'location.host', ''),
    pageURL: get(window, 'location.origin', ''),
    placement: 'webOneTimeAdd',
    storeId: get(upcomingOrder, 'storeId', ''),
    uiPageSize: 45, //As per the BIA team 45 is the limit
    assortmentChannel: get(upcomingOrder, 'fulfillment.fulfillmentType') === 'DUG' ? 'pickup' : 'delivery',
  };

  const queryParamsString = reduce(
    toPairs(queryParams),
    (query, [key, value], i) => {
      return `${query}${!!i ? '&' : ''}${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
    },
    '',
  );

  return snsAxiosClient(options).post(
    formatString(`${get(environmentVariables, 'SNS_BUYITAGAIN', 'buyitagain_products')}?${queryParamsString}`, {
      UUID: get(user, 'UUID'),
    }),
    payload,
  );
}

export default buyItAgainService;
